import { useState } from "react";
import WorkCard from "@/components/base/WorkCard";
import SectionHeading from "@/components/base/SectionHeading";
import { works } from "@/mocks/works";

const tabs = ["最新作品", "热门推荐", "电视剧", "电影"];

function filterWorks(tab: string) {
  if (tab === "电视剧") return works.filter((w) => w.type === "电视剧").slice(0, 8);
  if (tab === "电影") return works.filter((w) => w.type === "电影").slice(0, 8);
  if (tab === "热门推荐") return works.filter((w) => w.tags.includes("热门")).slice(0, 8);
  return [...works].sort((a, b) => b.year - a.year).slice(0, 8);
}

export default function WorksHighlight() {
  const [tab, setTab] = useState(tabs[0]);
  const list = filterWorks(tab);

  return (
    <section className="w-full px-4 md:px-8 py-14 md:py-20 bg-background-50">
      <SectionHeading
        kicker="影视作品精选"
        title="杨幂影视作品库"
        desc="精选最新与高热度的电视剧、电影作品，点击卡片查看完整资料。"
        morePath="/works"
      />

      <div className="flex items-center gap-1 bg-background-100 rounded-full p-1 w-fit mb-8 max-w-full overflow-x-auto">
        {tabs.map((t) => (
          <button
            key={t}
            onClick={() => setTab(t)}
            className={`px-4 py-1.5 rounded-full text-xs md:text-sm font-label whitespace-nowrap transition-colors cursor-pointer ${
              t === tab ? "bg-primary-500 text-background-50 font-semibold" : "text-foreground-600 hover:text-primary-600"
            }`}
          >
            {t}
          </button>
        ))}
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
        {list.map((work) => (
          <WorkCard key={work.id} work={work} />
        ))}
      </div>
    </section>
  );
}